"use client";

import Link from "next/link";
import { useState } from "react";
import { usePathname } from "next/navigation";

export default function Navbar() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (pathname === "/editor" || pathname.startsWith("/share")) return null;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-edge bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 text-lg font-semibold">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect width="28" height="28" rx="6" fill="#7c5cfc" />
            <path
              d="M8 20L18 8M18 8H12M18 8V14"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Pencil</span>
        </Link>

        {/* Desktop links */}
        <div className="hidden items-center gap-8 md:flex">
          <Link href="/pricing" className="text-sm text-muted transition-colors hover:text-foreground">
            Pricing
          </Link>
          <Link href="/downloads" className="text-sm text-muted transition-colors hover:text-foreground">
            Downloads
          </Link>
          <Link href="/docs" className="text-sm text-muted transition-colors hover:text-foreground">
            Docs
          </Link>
          <Link
            href="/editor"
            className="rounded-full bg-accent px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-accent-hover"
          >
            Open Editor
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="flex flex-col gap-1.5 md:hidden"
          aria-label="Toggle menu"
        >
          <span className={`block h-0.5 w-6 bg-foreground transition-transform ${mobileOpen ? "translate-y-2 rotate-45" : ""}`} />
          <span className={`block h-0.5 w-6 bg-foreground transition-opacity ${mobileOpen ? "opacity-0" : ""}`} />
          <span className={`block h-0.5 w-6 bg-foreground transition-transform ${mobileOpen ? "-translate-y-2 -rotate-45" : ""}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-edge bg-background px-6 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            <Link href="/pricing" className="text-sm text-muted hover:text-foreground" onClick={() => setMobileOpen(false)}>
              Pricing
            </Link>
            <Link href="/downloads" className="text-sm text-muted hover:text-foreground" onClick={() => setMobileOpen(false)}>
              Downloads
            </Link>
            <Link href="/docs" className="text-sm text-muted hover:text-foreground" onClick={() => setMobileOpen(false)}>
              Docs
            </Link>
            <Link
              href="/editor"
              className="mt-2 rounded-full bg-accent px-4 py-2 text-center text-sm font-medium text-white hover:bg-accent-hover"
              onClick={() => setMobileOpen(false)}
            >
              Open Editor
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
